// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';
import XHR from 'components/lib/swell-ui-0.0.3/utils/XHR';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

class PrincipalEditorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  render() {
    return (
      <div className="container">
        <h1><i className="fa fa-user-tie" /> Modifica direttore scolastico</h1>
      </div>
    );
  }
}

export default PrincipalEditorPage;


// WEBPACK FOOTER //
// ./src/pages/principals/PrincipalEditorPage.js